function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolitics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.128,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.902,6.753C15.951,3.766 18.802,1.628 22.149,1.628C25.496,1.628 28.347,3.766 29.396,6.753L32.399,6.753C35.226,6.753 37.524,9.051 37.524,11.878L37.524,37.503C37.524,40.33 35.226,42.628 32.399,42.628L11.899,42.628C9.072,42.628 6.774,40.33 6.774,37.503L6.774,11.878C6.774,9.051 9.072,6.753 11.899,6.753L14.902,6.753ZM24.711,9.316C24.711,7.898 23.566,6.753 22.149,6.753C20.731,6.753 19.586,7.898 19.586,9.316C19.586,10.733 20.731,11.878 22.149,11.878C23.566,11.878 24.711,10.733 24.711,9.316ZM19.586,31.097C19.586,31.802 20.163,32.378 20.868,32.378L31.118,32.378C31.822,32.378 32.399,31.802 32.399,31.097C32.399,30.392 31.822,29.816 31.118,29.816L20.868,29.816C20.163,29.816 19.586,30.392 19.586,31.097ZM14.461,33.019C15.526,33.019 16.383,32.162 16.383,31.097C16.383,30.032 15.526,29.175 14.461,29.175C13.396,29.175 12.539,30.032 12.539,31.097C12.539,32.162 13.396,33.019 14.461,33.019ZM19.586,23.409C19.586,24.114 20.163,24.691 20.868,24.691L31.118,24.691C31.822,24.691 32.399,24.114 32.399,23.409C32.399,22.705 31.822,22.128 31.118,22.128L20.868,22.128C20.163,22.128 19.586,22.705 19.586,23.409ZM14.461,25.331C15.526,25.331 16.383,24.474 16.383,23.409C16.383,22.344 15.526,21.487 14.461,21.487C13.396,21.487 12.539,22.344 12.539,23.409C12.539,24.474 13.396,25.331 14.461,25.331Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolitics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/politics.5d132166772f700c2efc2783376f9363.svg";